import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const qualityControlApi = createApi({
  reducerPath: 'qualityControlApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['QualityControl'],
  endpoints: (builder) => ({
    getQualityChecks: builder.query<unknown[], void>({
      query: () => 'quality-control',
      providesTags: ['QualityControl'],
    }),
    createQualityCheck: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'quality-control', method: 'POST', body }),
      invalidatesTags: ['QualityControl'],
    }),
    updateQualityCheck: builder.mutation<unknown, { id: string; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({ url: `quality-control/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['QualityControl'],
    }),
  }),
});

export const {
  useGetQualityChecksQuery,
  useCreateQualityCheckMutation,
  useUpdateQualityCheckMutation,
} = qualityControlApi;
